// @flow

// Utils
import _get from 'lodash/get'
import _some from 'lodash/some'
import _includes from 'lodash/includes'

// Constants
import {
  PROP_SEASON_ID,
  PROP_FILES,
  MAX_FILES_COUNT,
  FILE_EXTENSION,
} from 'hfty-model-import-jobs-tool'

import {
  MSG_ERROR_FILE_REQUIRED,
  MSG_ERROR_EXTRA_FILES,
  MSG_ERROR_WRONG_EXTENSION,
  MSG_ERROR_MISSING_SEASON,
} from 'hfty-import-jobs-tool-dom'

export default function validateModel (model: Object): Array<{ [string]: string }> {
  const season = _get(model, PROP_SEASON_ID, null)
  const files = _get(model, PROP_FILES, [])
  let errors = []

  if (model) {
    const seasonErrors = validateSeason(season)
    const filesErrors = validateFiles(files)

    errors = [].concat(seasonErrors, filesErrors)
  }

  return errors
}

export function validateSeason (season: number): Array {
  const errors = []

  if (!season) {
    errors.push({
      [PROP_SEASON_ID]: MSG_ERROR_MISSING_SEASON,
    })
  }

  return errors
}

export function validateFiles (files: Array = []): Array<Object> {
  const errors = []
  const isWrongExtension = _some(files, (file: Object): boolean => {
    const hasExpectedExtension = _includes(file.name, `.${FILE_EXTENSION}`) || _includes(file.type, FILE_EXTENSION)

    return !hasExpectedExtension
  })

  if (files.length === 0) {
    errors.push({
      [PROP_FILES]: MSG_ERROR_FILE_REQUIRED,
    })
  }

  if (files.length > MAX_FILES_COUNT) {
    errors.push({
      [PROP_FILES]: MSG_ERROR_EXTRA_FILES,
    })
  }

  if (isWrongExtension) {
    errors.push({
      [PROP_FILES]: MSG_ERROR_WRONG_EXTENSION,
    })
  }

  return errors
}
